import type { EntitlementStatus } from './types';

export function isStoreProEntitlement(entitlement: EntitlementStatus): boolean {
  return (
    entitlement.tier === 'pro' &&
    (entitlement.source === 'appstore' || entitlement.source === 'microsoft')
  );
}

export function canIssueWebRedeemCode(entitlement: EntitlementStatus): boolean {
  return isStoreProEntitlement(entitlement);
}
